import { LoginData, User } from "@cervval.js/common-auth/src/loginData.model";

export const CLIENT_AUTHENTICATION_SERVICE = "ClientAuthenticationService";

export interface ClientAuthenticationService<AppUser extends User = User, CustomLoginData extends LoginData<AppUser> = LoginData<AppUser>> {

    /**
     * Redirects the user to the login page or SSO application
     */
    redirectToLogin(): Promise<void>;

    /**
     * @returns the client loginData
     */
    getLoginData(): CustomLoginData;

    /**
     * @returns
     */
    setLoginData(loginData: CustomLoginData): void;
}